export enum TagModels {
    DRIVER = 'driver',
    CARRIER = 'carrier',
    VEHICLE = 'vehicle',
    ZONE = 'zone',
    TRIP = 'trip',
    ACCOUNT = 'account',
}
